/**
 * Re-export the shared 24-hour raincheck copy for receipts and invoices (CWS-1523).
 * Single implementation: libs/shared-utils/src/raincheckPolicy.js — the same module
 * svc-order reads when it appends the line to the purchase SMS, so the copy on the
 * invoice and the copy in the SMS cannot drift.
 */
import { RAINCHECK_MESSAGE, isRaincheckWashType } from '@car-wash/raincheck-policy';
import { InvoiceData } from '../../services/pdf.service';

export { RAINCHECK_MESSAGE, isRaincheckWashType };

/**
 * The raincheck is offered on single wash purchases only, so the receipt has to know
 * which wash this payment was for.
 *
 * `transaction.wash_type` is `orders.wash_type` straight from the transaction-history
 * API and is the authoritative value. The order is only a fallback: it reaches the
 * receipt either mapped for the orders table (`washTypeValue`) or as the raw API record
 * (`wash_type`), and neither is guaranteed on every print path.
 */
function resolveReceiptWashType(invoiceData: InvoiceData): string | null {
  const rawOrder = invoiceData.order as unknown as Record<string, unknown>;
  const candidates = [
    invoiceData.transaction?.wash_type,
    rawOrder?.['washTypeValue'],
    rawOrder?.['wash_type'],
  ];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim() !== '') {
      return candidate;
    }
  }
  return null;
}

/** True when this receipt/invoice should carry the 24-hour raincheck line. */
export function shouldShowRaincheckMessage(invoiceData: InvoiceData): boolean {
  return isRaincheckWashType(resolveReceiptWashType(invoiceData));
}
